module.exports = __webpack_public_path__ + "media/images/flags/NI-7efba808fb8573fc2389d295660e110a.svg";